import qs from "qs";
import { LogOut } from "./Token.helper";
const getCategoriesPerMentor = async () => {

    const categories = await fetch(`/api/categories/mentorCategories`, {
        method: 'GET',
        headers: {
            'accept': '*/*'
        }
    });
    if(!categories.ok){
        if(categories.status == 401){
            LogOut();
        }
        throw new Error;
    }

    const body = await categories.json();

    return body;
}

const getCategories = async () => {

    const categories = await fetch(`/api/categories/categories`, {
        method: 'GET',
        headers: {
            'accept': '*/*'
        }
    });
    if(!categories.ok){
        if(categories.status == 401){
            LogOut();
        }
        throw new Error;
    }

    const body = await categories.json();

    return body;
}

const getPublicCategories = async () => {

    const categories = await fetch(`/api/public/categories/categories`, {
        method: 'GET',
        headers: {
            'accept': '*/*'
        }
    });

    if(!categories.ok){
        throw new Error;
    }

    return await categories.json();
}

const deleteMentorCategory = async (idMentorCategory) => {
    const resp = await fetch(`/api/categories/mentorCategory?idMentorCategory=${idMentorCategory}`, {
        method: 'DELETE',
        headers: {
            'accept': '*/*'
        }
    });
}

const createMentorCategory = async (idCategory) => {
    await fetch(`/api/categories/mentorCategory?idCategory=${idCategory}`, {
        method: 'PUT',
        headers: {
            'accept': '*/*'
        }
    });
}

export {
    getCategoriesPerMentor,
    getCategories,
    deleteMentorCategory,
    createMentorCategory,
    getPublicCategories
}
